import {Injectable} from '@angular/core';
import {IFullGraphData, IGraphData, IGraphNode, ITagretsNodes} from '../models/graph-kn.model-interfaces';
import {GraphKnDataService} from './graph-kn.data.service';
import {BUSINESS_PROCESS_LAYER_ID} from '../models/graph-kn.cm-api-models';
import {of, switchMap, tap} from 'rxjs';
import {ContractDataService } from '../../contracts/services/contract-data.service';
import { MemberService } from '../../../services/member.service';
import { ContractAvatarsService } from '../../contracts/services/contract-avatar.service';
import { KN_STEPS_STYLES_MAP, TStepTypeCode } from '../styles/nodes-styles/graph-node-contract-step-styling';
import { RectModelsMap } from '../styles/graph-node-rect-model';
import { GraphKnHelperService } from './graph-kn.helpers.service';
@Injectable({
    providedIn: 'root'
})
export class GraphKnTransformService {
    constructor(
        private knDataService: GraphKnDataService,
        private graphHelpersService: GraphKnHelperService,
        private contractDataService: ContractDataService,
        private memberService: MemberService,
        private contractAvatarsService:ContractAvatarsService,
    ) {
    }

    transformIncomingContract(contractGD: IGraphData | undefined, contractGuid:string): IGraphData | undefined {
        if (contractGD === undefined) {
            return undefined
        }
        let rectModel = RectModelsMap.get('contractStep')!
        contractGD.stateContract = this.knDataService.contractStatus
        let contractData =  this.contractDataService.ContractDataCachedByGuid.get(contractGuid)
        contractData?.rights?.isCurrentMemberInContract === true ? null : contractGD.stateContract = 'closed'
        contractGD.nodes = contractGD.nodes.map((node, index) => {
            node.dimension = {width:rectModel.width!,height:rectModel.height!}
            node.state = contractGD.stateContract||"none",
            node.image = node.contract_step_data?.target_type ? KN_STEPS_STYLES_MAP.get(node.contract_step_data?.target_type as TStepTypeCode)?.icon : ''
            node.contract_step_data? node.contract_step_data.stepNumber = (index + 1).toString() : null;
            let stepTarget = node.contract_step_data? this.contractDataService.getCachedStepTargetData(node.contract_step_data) : null;
            if (node.contract_step_data && node.contract_step_data?.target_key && !stepTarget) {
                this.knDataService.loadingIds.push(node.id ) // добавляем элемент в массив статуса "загрузка"
            }
            return node;
        });
        return contractGD
    }

    transformIncomingSubContract(dataSubContract: IGraphData, contractNodes: ITagretsNodes[] | undefined): IFullGraphData | undefined {
        if (contractNodes === undefined) {
            return undefined
        }
        dataSubContract.nodes = dataSubContract.nodes
            .map((node, index) => {
                node.image = node.contract_step_data?.target?.target_type ? KN_STEPS_STYLES_MAP.get(node.contract_step_data?.target?.target_type as TStepTypeCode)?.icon : ''
                node.contract_step_data? node.contract_step_data.stepNumber = (index + 1).toString() : null;
                return node;
            })
        let subContractNodeIds = dataSubContract.nodes.map(node => node.id);
        dataSubContract.edges = dataSubContract.edges.filter(edge => subContractNodeIds.includes(edge.data.source) || subContractNodeIds.includes(edge.data.target));
        return dataSubContract
    }

    transformIncomingBP(dataInit: IGraphData): IGraphData {
        let rectModel = RectModelsMap.get('BPStatus')!
        let data = structuredClone(dataInit)
        let moveAlg = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)?.moveAlg || 'save'
        data.allUsers = []
        data.nodes.forEach(node => {
            node.dimension = {width: rectModel.width!, height: rectModel.height!}
            node.position = {x: 0, y: 0};
            data.allUsers?.push(...this.prepareUserList(node))
        })
        data.edges.forEach(edge => {
            edge.id = edge.id || edge.data.id
            edge.points_labels = []
            edge.target = edge.target || edge.data.target
            edge.source = edge.source || edge.data.source,
                edge.moveAlg = moveAlg
        })
        data.allUsers = Array.from(new Set(data.allUsers))
        this.getMemberData(data.allUsers)
        return  data;
    }

    transformIncomingTask(dataInit: IGraphData): IGraphData {
        let rectModel = RectModelsMap.get('TaskStep')!
        //временно убрал архивный статус из задач в контракте. занимает много места в слое при алогритме ELK. нужно искать настройку. наверное partitioning
        let data = structuredClone(dataInit)
        data.allUsers = []
        data.nodes.forEach(node => {
            node.dimension = {width: rectModel.width!, height: rectModel.height!}
            data.allUsers?.push(...this.prepareUserList(node))

        })
        data.allUsers = Array.from(new Set(data.allUsers))
        this.getMemberData(data.allUsers)
        return data;
    }

    prepareUserList(node:IGraphNode):string[] {
        let statusData = this.graphHelpersService.getStatusData(node)
        let userGuidsArr:string[] = [] 
            for (const key in statusData?.roles) {
            ((statusData?.roles as any)[key] )?.length? userGuidsArr.push((statusData?.roles as any)[key]):null
        }
       return userGuidsArr.flat()
    }

    getMemberData(guids:string[]) {
      of(guids.length===0).pipe(
        switchMap(res=>res === false? this.memberService.memberGuidsHandler(guids) : of([])),
        tap(data=>this.knDataService.BsUsersData.next(data)),
        switchMap(res=>{
            if (res.length === 0) {
                return of(new Map())
            } else {
                let guidsWithAvatars:string[] = res.filter(el=>el.has_avatar === true).map(el=>el.guid)
                let guidsWithOutAvatars:string[] = res.filter(el=>el.has_avatar === false).map(el=>el.guid)
                guidsWithOutAvatars.forEach(guid=>this.contractAvatarsService.setGenericAvatar(guid).subscribe())
                return this.contractAvatarsService.getAvatars(guidsWithAvatars)
            }
        }),
        tap(data=>this.knDataService.BsAvatarData.next(data)),
      ).subscribe()
    }
}